import * as Yup from "yup";
import { toast } from "react-toastify";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";

import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { Card, Grid, IconButton, InputAdornment } from "@mui/material";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import BasicLayout from "layouts/authentication/components/BasicLayout";

import apiClient from "api-client";

import { backgroundImage, tomarketLogo } from "assets/assets";

const ResetPassword = () => {
  const [hidePassword, setHidePassword] = useState(true);
  const [hideConfirmPassword, setHideConfirmPassword] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const resetToken = new URLSearchParams(location.search).get("resetToken");
  const email = new URLSearchParams(location.search).get("email");

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await apiClient.post("auth/reset-password", {
        resetToken,
        newPassword: values.password,
        email,
      });
      toast.success("Password reset successfully! Please login.");
      navigate("/authentication/signin");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to reset password.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleTogglePasswordVisibility = () => setHidePassword(!hidePassword);

  const handleToggleConfirmPasswordVisibility = () => setHideConfirmPassword(!hideConfirmPassword);

  return (
    <BasicLayout image={backgroundImage} formType="reset-password">
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          mx={2}
          mt={-3}
          p={2}
          textAlign="center"
        >
          <Grid item xs={12}>
            <MDBox
              component="img"
              sx={{ width: "80%", maxWidth: "400px", height: "100px", objectFit: "contain" }}
              src={tomarketLogo}
              alt="Logo"
            />
          </Grid>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <Formik
            initialValues={{ password: "", confirmPassword: "" }}
            validationSchema={Yup.object({
              password: Yup.string()
                .min(6, "Password must be at least 6 characters")
                .required("Password is required"),
              confirmPassword: Yup.string()
                .oneOf([Yup.ref("password")], "Passwords must match")
                .required("Confirm Password is required"),
            })}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <MDBox mb={2}>
                  <Field
                    name="password"
                    as={MDInput}
                    type={hidePassword ? "password" : "text"}
                    label="Password"
                    fullWidth
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                            {hidePassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <ErrorMessage name="password" component="h6" style={{ color: "red" }} />
                </MDBox>

                <MDBox mb={2}>
                  <Field
                    name="confirmPassword"
                    as={MDInput}
                    type={hideConfirmPassword ? "password" : "text"}
                    label="Confirm Password"
                    fullWidth
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleToggleConfirmPasswordVisibility} edge="end">
                            {hideConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <ErrorMessage name="confirmPassword" component="h6" style={{ color: "red" }} />
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="success"
                    fullWidth
                    disabled={isSubmitting}
                  >
                    Reset Password
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </Card>
    </BasicLayout>
  );
};

export default ResetPassword;
